var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 28,
    viewBox: "0 0 171 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77096 28H2.49379L12.0584 0H19.6072L29.1582 28H22.8811L15.941 6.39844H15.7245L8.77096 28ZM8.37863 16.9941H23.2057V21.6152H8.37863V16.9941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.493 0H39.7171L47.3472 18.8125H47.6718L55.3018 0H62.526V28H56.8441V9.77539H56.6141L49.4441 27.8633H45.5749L38.4049 9.70703H38.1749V28H32.493V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3523 28V0H78.2832C80.3846 0 82.1749 0.405599 83.654 1.2168C85.1331 2.01888 86.2604 3.13542 87.0361 4.56641C87.8207 5.98828 88.213 7.62891 88.213 9.48828C88.213 11.3477 87.8162 12.9883 87.0225 14.4102C86.2289 15.832 85.079 16.9395 83.5728 17.7324C82.0757 18.5254 80.2629 18.9219 78.1344 18.9219H71.1673V14.1777H77.1874C78.3148 14.1777 79.2437 13.9818 79.9742 13.5898C80.7138 13.1888 81.264 12.6374 81.6247 11.9355C81.9945 11.2246 82.1794 10.4089 82.1794 9.48828C82.1794 8.55859 81.9945 7.7474 81.6247 7.05469C81.264 6.35286 80.7138 5.81055 79.9742 5.42773C79.2347 5.03581 78.2967 4.83984 77.1603 4.83984H73.2101V28H67.3523Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0179 28V0H97.8757V23.1191H109.754V28H92.0179Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.491 0V28H113.633V0H119.491Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.31 28V0H142.655V4.88086H130.168V11.5527H141.437V16.4336H130.168V28H124.31Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.971 0H151.533L157.85 12.0586H158.121L164.439 0H171L160.894 18.1016V28H155.077V18.1016L144.971 0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 22.0534L10.7937 22.0534L10.7937 17.8934L6.66665 17.8933L6.66669 22.0534Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90488 10.5334L3.80966 10.5334L3.80964 8.61337L1.90486 8.61336L1.90488 10.5334Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 19.8141L8.57145 19.8141L8.57143 17.8941L6.66665 17.8933L6.66667 19.8141Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85743 15.6546L5.39714 15.6546L5.39711 13.0946L2.85741 13.0946L2.85743 15.6546Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15.974L8.57145 15.974L8.57143 17.8941L6.66665 17.8933L6.66667 15.974Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66291e-05 11.8145L1.58733 11.8145L1.58731 13.4145L0 13.4145L1.66291e-05 11.8145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.c5dc695cd10473a30940f2c7b63a1172.svg";
export { ForwardRef as ReactComponent };